<template>
    <b-card no-body>

        <b-modal id="create-or-update" size="lg" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <levy-create-or-update v-model="levy" :errors="errors" :editing="editing"></levy-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <b-modal id="reject" size="md" title="İcra Reddi" no-close-on-esc no-close-on-backdrop>
            <levy-reject v-model="rejectData"></levy-reject>
            <template #modal-footer><v-executer :loading="rejecting" :action="reject" text="Reddet"></v-executer></template>
        </b-modal>

        <b-modal id="installment" size="lg" hide-footer body-class="p-0" :title="['İcra Taksitleri',$safe(levy,'Employee.FullName') || null].join(' - ')" no-close-on-esc no-close-on-backdrop>
            <levy-installment v-model="levy" v-on:update="$refs.table.refresh()"></levy-installment>
        </b-modal>

        <b-modal id="payments" size="lg" hide-footer body-class="p-0" :title="['Ödenen İcralar',$safe(levyPayments,'Employee.FullName') || null].join(' - ')" no-close-on-esc no-close-on-backdrop>
            <levy-payments-list :levy="levyPayments" v-on:refresh="onPaymentUpdate"></levy-payments-list>
        </b-modal>

        <b-modal id="files" size="lg" hide-footer body-class="p-0" :title="['İcra Dosyaları',file.FullName,file.FileNumber].join(' - ')" no-close-on-esc no-close-on-backdrop>
            <levy-file v-model="file"></levy-file>
        </b-modal>

        <b-modal id="logs" size="lg" hide-footer body-class="p-0" :title="['İcra Güncelleme Geçmişi',$safe(levyLogs,'fullName') || null].join(' - ')" no-close-on-esc no-close-on-backdrop>
            <levy-logs v-model="levyLogs"/>
        </b-modal>

        <b-modal id="upload-excel" size="lg" title="Excel Yükle" no-close-on-esc no-close-on-backdrop>
            <levy-upload-excel v-model="uploadExcelData"></levy-upload-excel>
            <template #modal-footer><v-executer :loading="uploadingExcel" :action="doUploadExcel" :disabled="!uploadExcelData.File" text="Yükle"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    class="levy-table"
                    name="levy-installment"
                    :add-callback="createNew"
                    v-on:component-action="onAction"
                    search
                    v-on:fetch-result="$event => result = $event"
                    pagination="server"
                    button-alignment="text-right">
                        <template #filters>
                            <levy-filter v-on:filter="filter"></levy-filter>
                        </template>
                        <template #custom-html>
                            <div class="alert alert-primary mb-75 mx-1">
                                <div class="alert-body py-50 px-75 d-flex align-items-center justify-content-between">
                                    <span>
                                        Toplam İcra: <b class="font-weight-bolder">{{ $safe(result,'TotalLevyCount') || 0 }}</b>
                                    </span>
                                    <v-executer class="btn-sm" :action="downloadExcel" text="Excel İndir" v-if="$safe(result,'ExcelPath')" />
                                </div>
                            </div>
                        </template>
                    </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import LevyCreateOrUpdate from './components/LevyCreateOrUpdate.vue'
import LevyInstallment from './components/LevyInstallment.vue'
import moment from 'moment'
import Additional from '@/utilities/additional'
import LevyFilter from './components/LevyFilter.vue'
import LevyReject from './components/LevyReject.vue'
import LevyFile from './components/LevyFile.vue'
import LevyPaymentsList from './components/LevyPaymentsList.vue'
import LevyLogs from './components/LevyLogs.vue'
import LevyUploadExcel from './components/LevyUploadExcel.vue'

export default {
    components:{
        BCard,
        LevyCreateOrUpdate,
        LevyInstallment,
        LevyFilter,
        LevyReject,
        LevyFile,
        LevyPaymentsList,
        LevyLogs,
        LevyUploadExcel
    },
    data() {
        return {
            buttons:[],
            loading:false,
            errors:{},
            uploadingExcel:false,
            uploadExcelData:{
                EmployeeId:null,
                File:null
            },
            fields:[
                {name:"Personel",key:"FullName",tdClass:'align-baseline text-nowrap p-75'},
                {name:"Kimlik Numarası",key:"IdentityNumber",tdClass:'align-baseline text-nowrap p-75'},
                {
                    name:"İcra Detayları",
                    thClass:'w-100',
                    component:true,
                    componentOptions:{name:"employee-levy-detail/EmployeeLevyDetail"},
                },
            ],
            editing:false,
            rejecting:false,
            levy:{
                Id:null,
                OrderNumber:null,
                SGKBranchId:null,
                EmployeeId:null,
                Employee:null,
                CommuniqueType:null,
                OfficialOrderNumber:null,
                CommuniquedDate:null,
                LevyOfficeId:null,
                FileNumber:null,
                BaseFileNumber:null,
                Payee:null,
                PayeeGovernment:false,
                LevyOfficeBankAccountNumber:null,
                TotalDebtAmount:null,
                BaseTotalDebtAmount:null,
                FixedDeduction:false,
                CurrentRemainingDebt:null,
                FirstInstallmentDate:null,
                InstallmentCount:1,
                Active:true,
                DateForOrder:null,
                Orders:[],
                ShowDateOrder:false,
                Accepted:null,
                OrderDescription:null,
                RejectDescription:null,
                AnswerDate:null,
                PaidAmount:null,
                AmountChangeDescription:null,
                FileNumberChangeDescription:null,
            },
            filterData:{
                Active:null,
                BranchTypeCode:'O',
                BranchId:null,
                CollarStatusId:null,
                Month:null,
                Year:null,
                EmployeeId:null,
                SalaryPaymentDate:null,
            },
            rejectData:{
                Id:null,
                Description:null,
                FullName:null,
                FileNumber:null,
                RejectDate:null,
            },
            file:{
                FullName:null,
                FileNumber:null,
                EmployeeId:null,
                Id:null,
            },
            levyPayments:{},
            result:null,
            levyLogs:{
                fullName:null,
                logs:[]
            }
        }
    },
    methods:{
        filter(data){
            this.filterData = data
            this.$refs.table.refresh()
        },
        clearForm(){
            this.editing = false
            this.levy.Id = null
            this.levy.OrderNumber = null
            this.levy.SGKBranchId = null
            this.levy.EmployeeId = null
            this.levy.Employee = null
            this.levy.CommuniqueType = null
            this.levy.OfficialOrderNumber = null
            this.levy.CommuniquedDate = null
            this.levy.LevyOfficeId = null
            this.levy.FileNumber = null
            this.levy.BaseFileNumber = null
            this.levy.Payee = null
            this.levy.PayeeGovernment = false
            this.levy.LevyOfficeBankAccountNumber = null
            this.levy.TotalDebtAmount = null
            this.levy.BaseTotalDebtAmount = null
            this.levy.FixedDeduction = false
            this.levy.Active = false
            this.levy.DateForOrder = null
            // this.levy.CurrentRemainingDebt = null
            this.levy.FirstInstallmentDate = null
            this.levy.Orders = []
            this.levy.ShowDateOrder = false
            this.levy.Accepted = null
            this.levy.OrderDescription = null
            this.levy.RejectDescription = null
            this.levy.AnswerDate = null
            this.levy.PaidAmount  = null
            this.levy.AmountChangeDescription  = null
            this.levy.FileNumberChangeDescription  = null
            this.errors = {}
            // this.levy.InstallmentCount = 0
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return EmployeeOperationsApi.Levy.Table({
                Active:this.filterData.Active,
                HRFilter:{
                    PaginateRequest: data,
                    BranchTypeCode: this.filterData.BranchTypeCode,
                    CollarStatusId: this.filterData.CollarStatusId,
                    BranchId: this.filterData.BranchId,
                    Month: 1,
                    Year: 2024,
                    EmployeeId: this.filterData.EmployeeId,
                    SalaryPaymentDate: this.filterData.SalaryPaymentDate,
                }
            })
        },
        onAction(key,item,table,row){
            if(key == 'edit') this.edit(item)
            else if(key == 'delete') this.delete(item)
            else if(key == 'download') this.download(item)
            else if(key == 'deactivate') this.deactivate(item,table)
            else if(key == 'reject') this.openReject(item,table,row)
            else if(key == 'files') this.openFile(item,row)
            else if(key == 'payments') this.openPayments(item,row)
            else if(key == 'logs') this.openLogs(item,row)
            else if(key == 'toggleactive') this.toggleActive(item,table,row)
            else if(key == 'uploadexcel') this.openUploadExcel(item,row)
        },
        clearReject(){
            this.rejectData.Id = null
            this.rejectData.Description = null
            this.rejectData.FullName = null
            this.rejectData.FileNumber = null
            this.rejectData.RejectDate = null
        },
        openReject(levy,table,row){
            this.clearReject()
            this.rejectData.Id = levy.Id
            this.rejectData.FileNumber = levy.FileNumber
            this.rejectData.FullName = row.FullName 
            this.$showModal('reject')
        },
        openPayments(levy,row){
            this.levyPayments = {}
            this.levyPayments = levy
            this.$showModal('payments')
        },
        onPaymentUpdate(){
            this.$refs.table.refresh()
            this.$hideModal('payments')
        },
        reject(){
            this.rejecting = true
            EmployeeOperationsApi.Levy.Reject({Id:this.rejectData.Id,Description:this.rejectData.Description}).then(res=>{
                this.$result(res)
                this.rejecting = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('reject')
                }
            }).catch(err=>{
                this.$result(null,err)
                this.rejecting = false
            })
        },
        openFile(item,row){
            this.file.Id = item.Id,
            this.file.FileNumber = item.FileNumber
            this.file.FullName = item?.Employee?.FullName
            this.file.EmployeeId = item?.Employee?.Id
            this.$showModal('files')
        },
        openLogs(item,row){
            this.levyLogs = {
                fullName:null,
                logs:[]
            }
            this.levyLogs.logs = item.ChangeLogs?.map(l => ({...l,CombineName:`${l.UserFullName} (${l.Username})`})) || []
            this.levyLogs.fullName = item.Employee?.FullName || null
            this.$showModal('logs')
        },
        installment(item){
            this.clearForm()
            this.levy.Id = item.Id
            this.levy.OrderNumber = item.OrderNumber
            this.levy.SGKBranchId = item.SGKBranch?.Id || null
            this.levy.Employee = item.Employee
            this.levy.EmployeeId = item.Employee?.Id || null
            this.levy.CommuniqueType = item.CommuniqueType
            this.levy.OfficialOrderNumber = item.OfficialOrderNumber
            this.levy.CommuniquedDate = item.CommuniquedDate
            this.levy.LevyOfficeId = item.LevyOffice?.Id || null
            this.levy.FileNumber = item.FileNumber
            this.levy.BaseFileNumber = item.FileNumber
            this.levy.Payee = item.Payee
            this.levy.PayeeGovernment = item.PayeeGovernment
            this.levy.LevyOfficeBankAccountNumber = item.LevyOfficeBankAccountNumber
            this.levy.TotalDebtAmount = item.TotalDebtAmount
            this.levy.BaseTotalDebtAmount = item.TotalDebtAmount
            this.levy.FixedDeduction = item.FixedDeduction
            this.levy.PaidAmount = item.PaidAmount
            this.levy.AmountChangeDescription = item.AmountChangeDescription
            this.levy.FileNumberChangeDescription = item.FileNumberChangeDescription
            // this.levy.CurrentRemainingDebt = item.CurrentRemainingDebt
            this.levy.FirstInstallmentDate = moment(item.FirstInstallmentDate,'DD.MM.YYYY').format('YYYY-MM-DD')
            // this.levy.InstallmentCount = item.InstallmentCount || 0
            this.$showModal('installment')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.levy.Id = item.Id
            this.levy.OrderNumber = item.OrderNumber
            this.levy.SGKBranchId = item.SGKBranch?.Id || null
            this.levy.Employee = item.Employee
            this.levy.EmployeeId = item.Employee?.Id || null
            this.levy.CommuniqueType = item.CommuniqueType
            this.levy.OfficialOrderNumber = item.OfficialOrderNumber
            this.levy.CommuniquedDate = item.CommuniquedDate
            this.levy.LevyOfficeId = item.LevyOffice?.Id || null
            this.levy.FileNumber = item.FileNumber
            this.levy.BaseFileNumber = item.FileNumber
            this.levy.Payee = item.Payee
            this.levy.LevyOfficeBankAccountNumber = item.LevyOfficeBankAccountNumber
            this.levy.TotalDebtAmount = item.TotalDebtAmount
            this.levy.BaseTotalDebtAmount = item.TotalDebtAmount
            this.levy.FixedDeduction = item.FixedDeduction
            this.levy.CurrentRemainingDebt = item.CurrentRemainingDebt
            this.levy.PayeeGovernment = item.PayeeGovernment
            this.levy.FirstInstallmentDate = item.FirstInstallmentDate
            this.levy.InstallmentCount = item.InstallmentCount
            this.levy.Active = item.Active
            this.levy.DateForOrder = item.DateForOrder
            this.levy.ShowDateOrder = item.DateForOrder != null ? true : false
            this.levy.Accepted = item.Accepted
            this.levy.OrderDescription = item.OrderDescription
            this.levy.RejectDescription = item.RejectDescription
            this.levy.PaidAmount = item.PaidAmount
            this.levy.AnswerDate = item.AnswerDate
            this.levy.AmountChangeDescription = item.AmountChangeDescription
            this.levy.FileNumberChangeDescription = item.FileNumberChangeDescription
            this.$showModal('create-or-update')
        },
        payTMSVault(item){
            this.pay(item,true)
        },
        pay(item,bool){
            this.$refs.table.rowLoading(true)
            EmployeeOperationsApi.Levy.Payment.Update({
                EmployeeLevyId:item.Id,
                PaidAmount:item.TotalDebtAmount,
                PaymentDate:moment(item.FirstInstallmentDate,'DD.MM.YYYY').format('YYYY-MM-DD'),
                PaidDate:moment().format('YYYY-MM-DD'),
                PaidOnTime:false,
                InstallmentNumber:1,
                TMSVault:bool
            }).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$refs.table.rowLoading(false)
                }
            }).catch(err=>{
                this.loading = false
                this.$refs.table.rowLoading(false)
            })
        },
        createOrUpdate(){
            this.loading = true
            EmployeeOperationsApi.Levy.CreateOrUpdate(this.editing,{
                ...this.levy,
                Active:this.editing ? this.levy.Active : true,
                Orders:this.levy.Orders?.filter(d=>d.Id) || []
            }).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        download(item){
            this.$refs.table.rowLoading(true)
            Additional.GetBlobFile(item.FilePath).then(blob=>{
                let fileSplt = item.FilePath?.split('.') || []
                let fileExt = fileSplt[fileSplt.length-1]
                let fileName = [item.Employee?.FullName,'-','İcra Belgesi','.',fileExt].join('')
                Additional.DownloadFile(blob.data,fileName)
                this.$refs.table.rowLoading(false)
            }).catch(err=>{
                this.$refs.table.rowLoading(false)
            })
        },
        deactivate(item,table){
            table.rowLoading(true)
            EmployeeOperationsApi.Levy.Deactivate(item.Id).then(res=>{
                this.$result(res)
                table.rowLoading(false)
                if(res.data.Success){
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.$result(null,err)
                table.rowLoading(false)
            })
        },
        toggleActive(item,table){
            table.rowLoading(true)
            EmployeeOperationsApi.Levy.ToggleActive(item.Id).then(res=>{
                this.$result(res)
                table.rowLoading(false)
                if(res.data.Success){
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.$result(null,err)
                table.rowLoading(false)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Employee?.FullName} personeline ait ${item.CommuniquedDateStr} tebliğ tarihli ${item.FileNumber} numaralı icra dosyasını silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    EmployeeOperationsApi.Levy.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
        downloadExcel(){
            if(this.$safe(this.result,'ExcelPath')){
                Additional.DownloadTab(this.$safe(this.result,'ExcelPath'))
            }
        },
        openUploadExcel(item, row){
            this.uploadExcelData.File = null
            this.uploadExcelData.EmployeeId =
                item?.Employee?.Id ||
                item?.EmployeeId ||
                row?.EmployeeId ||
                row?.Id ||
                row?.Employee?.Id ||
                row?.Levies?.[0]?.Employee?.Id ||
                null
            this.$showModal('upload-excel')
        },
        async doUploadExcel(){
            this.uploadingExcel = true
            let formData = await Additional.ToFormData(this.uploadExcelData, ['File'])
            EmployeeOperationsApi.Levy.UploadExcel(formData).then(res => {
                this.$result(res)
                this.uploadingExcel = false
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('upload-excel')
                }
            }).catch(err => {
                this.$result(null, err)
                this.uploadingExcel = false
            })
        }
    }
}
</script>

<style>
.levy-table tbody tr:hover{
    background: transparent;
}

.dark-layout .levy-table tbody tr:hover{
    background: transparent;
}


.levy-detail-table tbody tr:hover{
    background: #f6f6f9;
}

.dark-layout .levy-detail-table tbody tr:hover{
    background: #242b3d;
}
</style>
